export default "__VITE_ASSET__wAsFodtL__"